import { Controller } from "@hotwired/stimulus"
import { FriendlyCaptchaSDK } from "@friendlycaptcha/sdk"

const sdk = new FriendlyCaptchaSDK();

export default class extends Controller {
  connect () {
    this.widget = sdk.createWidget({
      element: this.element,
      sitekey: this.element.getAttribute("data-sitekey"),
      startMode: "focus"
    });

  }

  destroy() {
    this.widget.destroy()
    sdk.clear()
  }
}
